/**
 * Validation utilities for map clustering
 */

/**
 * Validates if bounds is a valid tuple of four numbers
 */
export const isValidBounds = (bounds: unknown): bounds is [number, number, number, number] => {
  return Array.isArray(bounds) && bounds.length === 4 && bounds.every((v) => typeof v === 'number' && !isNaN(v) && isFinite(v));
};

/**
 * Validates if zoom is a valid number
 */
export const isValidZoom = (zoom: unknown): zoom is number => {
  return typeof zoom === 'number' && !isNaN(zoom) && isFinite(zoom);
};
